module.exports = __webpack_public_path__ + "media/assets/icons/back-blue@3x-85b7bf27a05a759eff2c0438d2db77e1.png";